import $ from 'jquery';

/**
 * A Singleton class that handles loading external scripts.
 * Returns a promise and changes state when the script is loaded.
 * The same script can be called multiple times and will only be loaded once.
 */
let instance = null;

export default class ExternalScriptLoader {
    constructor() {
        if (! instance) {
            instance = this;
            this.requestedScripts = {};
        }

        return instance;
    }

    loaded(url) {
        let me = this;

        if (! me.requestedScripts.hasOwnProperty(url)) {
            me.requestedScripts[url] = $.Deferred();
            me.requestedScripts[url].notify('Loading script...');

            $.getScript(url, function () {
                me.requestedScripts[url].resolve('Script Loaded!');
            });
        }

        return me.requestedScripts[url].promise();
    }
}
